<template>
  <div class="animated fadeIn list-of-procure">
    <b-card>
      <div slot="header">PURCHASE REQUEST - HISTORY STATUS 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="3">
            <b-input-group >
                <b-input-group-prepend><label>Purchase Request #</label></b-input-group-prepend>
                <b-form-input readonly v-model="filter.vendorinfo" ></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuPrShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><label>Request  By</label></b-input-group-prepend>
                <b-form-input v-model="filter.createby" disabled></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="3">
            <b-input-group >
                <b-input-group-prepend><label>Expected</label></b-input-group-prepend>
                <b-form-input v-model="filter.expected" disabled></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="2">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table style="width: 100%;">
              <thead>
                  <tr>
                    <th width="90px">Date</th>
                    <th width="100px">Progress Name</th>
                    <th width="100px">Doc. Number</th>
                    <th>Item Name</th>
                    <th >Progress By</th>
                    <th>Remark</th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="row in rptLines" :key="row.tablekey" @click.stop="confirmAction()">
                    <td :class="row.kelas"><span v-if="row.tanggal"> {{row.tanggal | moment("DD MMM YYYY")}}</span></td>
                    <td :class="row.kelas">{{row.pogressName}}</td>
                    <td :class="row.kelas">{{row.nomor}}</td>
                    <td :class="row.kelas">{{row.itemname}}</td>
                    <td :class="row.kelas">{{row.progressBy}}</td>
                    <td :class="row.kelas">{{row.uraian}}</td>
                </tr>
              </tbody>
          </table>
      </div>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuPrShow" size="lg" :hide-footer="true" title="List of Purchase Request " :centered="true">
            <lku-pr @click="onSelectLkuPr"></lku-pr>
        </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }

            td.payment {
                font-style: italic;
                background-color: rgba(0, 0, 0, 0.05) !important;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
                height: 40px;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }
        }

    }
 
</style>

<script>
import moment from 'moment';
import procure from "../../apis/procure";
import lkuPr from "../lookup/lkuPr";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        requestno: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      lkuPrShow:false,
      reportUrl: null,
      filter: {vendor:'',matauang:this.$store.state.user.matauang, tgl2:'', alltrx:0},
      currency: [],
      rptLines : [],
      subtotal :{debit: 0, credit:0 , outstand:0}
    };
  },
  components: { Loading,lkuPr},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },  
  created: async function(){
        // this.currency = await procure.currency();
    //   const matauang = await procure.currency();
    //   this.currency = matauang.reduce((newArr,item) =>{
    //         newArr.push(item);
    //         return newArr;
    //     },[{ value: '', text: '-ALL-'}]);

        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.filter.tgl1=this.$store.state.user.tglaktif;
        this.filter.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onSelectLkuPr: async function (_selected) {
        this.filter.createby = _selected.createby;
        this.filter.expected = _selected.expected;
        this.filter.requestkey = _selected.requestkey;
        this.filter.requestno = _selected.requestno;
        this.lkuPrShow=false;
    },
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        const result = await procure.poinvpaym(this.filter);   
        if (result.success) {
            this.rptLines = result.data[0];   
            this.subtotal = result.data[2];
        } else {
          toastr.error(result.message,'ERROR',10000);
        }

        this.isLoading=false;      
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    },
    printJv: async function(data){
        this.showConfirmAction=false;
        this.showList=false;
       if ((data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await procure.printjv(data);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.showReport=true;
                this.reportUrl= await procure.poinvpaymprint(this.filter);
                this.isLoading=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await procure.poinvpaymexport(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("/treasury/home");
    }
  }
};
</script>
